// extracted by mini-css-extract-plugin
export default {"base":"Divider_base__-G4M6","isDashed":"Divider_isDashed__yzq8S"};